import { Input } from '@/components/ui/input'
import { useTranslation } from 'react-i18next'
import { ClientsTableParams } from '..'
import { debounceAsync } from '@/utils/debounce'
import { DataTableViewOptions } from '@/components/data-table/data-table-view-options'
import { Table } from '@tanstack/react-table'

interface DataTableToolbarProps<TData> {
  table: Table<TData>
  params: ClientsTableParams,
  setParams: React.Dispatch<React.SetStateAction<ClientsTableParams>>
}

export function DataTableToolbar<TData>({
  table,
  params,
  setParams
}: DataTableToolbarProps<TData>) {
  const i18n = useTranslation()
  const search = debounceAsync(async (value: string) => {
    setParams({ ...params, name: value == "" ? null : value })
  }, 500)

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    search(event.target.value);
  }

  return (
    <div className='flex items-center justify-between'>
      <div className='flex flex-1 flex-col-reverse items-start gap-y-2 sm:flex-row sm:items-center sm:space-x-2'>
        <Input
          defaultValue={params.name || ""}
          placeholder={i18n.t('search_by_name')}
          onChange={handleSearchChange}
          className='h-8 w-[150px] lg:w-[250px]'
        />
      </div>
      <DataTableViewOptions table={table} />
    </div>
  )
}
